import type { LawFirmCaseMaintainerMap, LawFirmCaseMaintainerMapExtra } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const GetByLawFirmCaseEncryptionId = params => $apiGet<(LawFirmCaseMaintainerMap & LawFirmCaseMaintainerMapExtra)[]>(`/v1/lawFirmCaseMaintainerMap/byLawFirmCaseEncryptionId`, params)

export const GetMyNewItem = () => $apiGet<LawFirmCaseMaintainerMap & LawFirmCaseMaintainerMapExtra>(`/v1/lawFirmCaseMaintainerMap/myNewItem`)
